import React, { useEffect, useState } from 'react';
import { Button } from 'react-bootstrap';
import { availableArtworkControls, showArtworkControls, subscribeArtworkControls } from '../../utils/artworkControlsMenu';

export default function ArtworkControlsMenu() {
  const [available, setAvailable] = useState(availableArtworkControls);
  useEffect(() => {
    const update = () => setAvailable(availableArtworkControls());
    const unsubscribe = subscribeArtworkControls(update);
    update();
    return unsubscribe;
  }, []);
  return available ? <>&nbsp;<Button variant="outline-secondary" size="sm" className="font-display"
    data-artwork-controls="menu" onClick={showArtworkControls}>Artwork controls</Button></> : null;
}
